<template>
  <div class="main">
    <ul>
      <li class="dateinput">
        <span v-if="!ratio">参照日期</span>
        <span v-else>对比日期</span>
        <el-date-picker class="date-picker" v-model="timeage" @change="searchyeardata" :clearable="false" type="daterange"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </li>
      <li style="margin-left: 10px;">
        <span>销售额</span>
        <span>{{ this.$formatNumber(yeardata.sales_Revenue) }} </span>
        <span :style="{ color: ratio.sales_Revenue > 0 ? '#f36161' : '#8ce78c' }" v-if="ratio">
          <i class="el-icon-top" v-if="ratio.sales_Revenue > 0"></i>
          <i v-else class="el-icon-bottom"></i>
          <i v-if="ratio.sales_Revenue > 0"> +</i>{{ ratio.sales_Revenue }}%</span>
        <span :style="{
          color: beforeratio.sales_Revenue > 0 ? '#f36161' : '#8ce78c',
        }" v-if="beforeratio">
          <i class="el-icon-top" v-if="beforeratio.sales_Revenue > 0"></i>
          <i v-else class="el-icon-bottom"></i>
          <i v-if="beforeratio.sales_Revenue > 0"> +</i>
          {{ beforeratio.sales_Revenue }}%</span>
      </li>
      <li>
        <span>实销量</span>
        <span>{{ this.$formatNumber(yeardata.sales_Quantity) }}</span>
        <span :style="{ color: ratio.sales_Quantity > 0 ? '#f36161' : '#8ce78c' }" v-if="ratio">
          <i class="el-icon-top" v-if="ratio.sales_Quantity > 0"></i>
          <i v-else class="el-icon-bottom"></i>
          <i v-if="ratio.sales_Quantity > 0"> +</i>
          {{ ratio.sales_Quantity }}%</span>
        <span :style="{
          color: beforeratio.sales_Quantity > 0 ? '#f36161' : '#8ce78c',
        }" v-if="beforeratio">
          <i class="el-icon-top" v-if="beforeratio.sales_Quantity > 0"></i>
          <i v-else class="el-icon-bottom"></i>
          <i v-if="beforeratio.sales_Quantity > 0"> +</i>
          {{ beforeratio.sales_Quantity }}%</span>
      </li>
      <li>
        <span>景区数</span>
        <span>{{ this.$formatNumber(yeardata.scenic_Spot) }}</span>
        <span :style="{ color: ratio.scenic_Spot > 0 ? '#f36161' : '#8ce78c' }" v-if="ratio">
          <i class="el-icon-top" v-if="ratio.scenic_Spot > 0"></i>
          <i v-else class="el-icon-bottom"></i>
          <i v-if="ratio.scenic_Spot > 0"> +</i>{{ ratio.scenic_Spot }}%</span>
        <span v-if="beforeratio" :style="{
          color: beforeratio.scenic_Spot > 0 ? '#f36161' : '#8ce78c',
        }">
          <i class="el-icon-top" v-if="beforeratio.scenic_Spot > 0"></i>
          <i v-else class="el-icon-bottom"></i>
          <i v-if="beforeratio.scenic_Spot > 0"> +</i>{{ beforeratio.scenic_Spot }}%</span>
      </li>
      <li>
        <span>sku数</span>
        <span>{{ this.$formatNumber(yeardata.sku_Num) }}</span>
        <span v-if="ratio" :style="{ color: ratio.sku_Num > 0 ? '#f36161' : '#8ce78c' }">
          <i class="el-icon-top" v-if="ratio.sku_Num > 0"></i>
          <i v-else class="el-icon-bottom"></i>
          <i v-if="ratio.sku_Num > 0"> +</i>{{ ratio.sku_Num }}%</span>
        <span v-if="beforeratio" :style="{ color: beforeratio.sku_Num > 0 ? '#f36161' : '#8ce78c' }">
          <i class="el-icon-top" v-if="beforeratio.sku_Num > 0"></i>
          <i v-else class="el-icon-bottom"></i>
          <i v-if="beforeratio.sku_Num > 0"> +</i>{{ beforeratio.sku_Num }}%</span>
      </li>
      <li>
        <span>设备数</span>
        <span>{{ this.$formatNumber(yeardata.deviece_num) }}</span>
        <span v-if="ratio" :style="{ color: ratio.deviece_num > 0 ? '#f36161' : '#8ce78c' }">
          <i class="el-icon-top" v-if="ratio.deviece_num > 0"></i>
          <i v-else class="el-icon-bottom"></i>
          <i v-if="ratio.deviece_num > 0"> +</i>{{ ratio.deviece_num }}%</span>
        <span v-if="beforeratio" :style="{
          color: beforeratio.deviece_num > 0 ? '#f36161' : '#8ce78c',
        }">
          <i class="el-icon-top" v-if="beforeratio.deviece_num > 0"></i>
          <i v-else class="el-icon-bottom"></i>
          <i v-if="beforeratio.deviece_num > 0"> +</i>{{ beforeratio.deviece_num }}%</span>
      </li>
      <li>
        <span>单台销售额</span>
        <span v-if="yeardata.single_unit_Sales > 0">{{ (yeardata.single_unit_Sales).toFixed(2) }}</span>
        <span v-if="ratio" :style="{
          color: ratio.single_unit_Sales > 0 ? '#f36161' : '#8ce78c',
        }">
          <i class="el-icon-top" v-if="ratio.single_unit_Sales > 0"></i>
          <i v-else class="el-icon-bottom"></i>
          <i v-if="ratio.single_unit_Sales > 0"> +</i>{{ ratio.single_unit_Sales }}%</span>
        <span v-if="beforeratio" :style="{
          color: beforeratio.single_unit_Sales > 0 ? '#f36161' : '#8ce78c',
        }">
          <i class="el-icon-top" v-if="beforeratio.single_unit_Sales > 0"></i>
          <i v-else class="el-icon-bottom"></i>
          <i v-if="beforeratio.single_unit_Sales > 0"> +</i>{{ beforeratio.single_unit_Sales }}%</span>
      </li>
      <li>
        <span>退款数</span>
        <span>{{ this.$formatNumber(yeardata.refund_Amount) }}</span>
        <span v-if="ratio" :style="{ color: ratio.refund_Amount > 0 ? '#f36161' : '#8ce78c' }">
          <i class="el-icon-top" v-if="ratio.refund_Amount > 0"></i>
          <i v-else class="el-icon-bottom"></i>
          <i v-if="ratio.refund_Amount > 0"> +</i>{{ ratio.refund_Amount }}%</span>
        <span v-if="beforeratio" :style="{
          color: beforeratio.refund_Amount > 0 ? '#f36161' : '#8ce78c',
        }">
          <i class="el-icon-top" v-if="beforeratio.refund_Amount > 0"></i>
          <i v-else class="el-icon-bottom"></i>
          <i v-if="beforeratio.refund_Amount > 0"> +</i>{{ beforeratio.refund_Amount }}%</span>
      </li>
      <li>
        <span>退款率</span>
        <span v-if="yeardata.refund_Rate > 0">{{ (yeardata.refund_Rate * 100).toFixed(2) }}%</span>
        <span v-if="ratio" :style="{ color: ratio.refund_Rate > 0 ? '#f36161' : '#8ce78c' }">
          <i class="el-icon-top" v-if="ratio.refund_Rate > 0"></i>
          <i v-else class="el-icon-bottom"></i>
          <i v-if="ratio.refund_Rate > 0"> +</i>{{ ratio.refund_Rate }}%</span>
        <span v-if="beforeratio" :style="{
          color: beforeratio.refund_Rate > 0 ? '#f36161' : '#8ce78c',
        }">
          <i class="el-icon-top" v-if="beforeratio.refund_Rate > 0"></i>
          <i v-else class="el-icon-bottom"></i>
          <i v-if="beforeratio.refund_Rate > 0"> +</i>{{ beforeratio.refund_Rate }}%</span>
      </li>
      <li style="width: 150px; text-align: center; padding: 0px;" @click="deletedata">
        <i style="width: 100%; margin: 0; padding: 0;" class="el-icon-delete"></i>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "yeardata",
  props: {
    yeardata: {
      type: Object,
      default: () => { },
    },
    ratio: {
      type: Object,
      default: () => { },
    },
    beforeratio: {
      type: Object,
      default: () => { },
    },
    id: {
      type: String, // 区分添加
      default: null,
    },
    time: {
      type: Array, // 区分添加
      default: () => [],
    }
  },
  data() {
    return {
      timeage: this.time || [],
    };
  },
  created() {
  },
  methods: {
    // 切换日期时候查询对应数据 此处需要触发父组件的方法
    searchyeardata() {
      console.log(this.timeage);
      this.$emit("searchdata", this.timeage, this.id)
    },
    // 隐藏或删除该条数据
    deletedata() {
      this.$emit("deletedata", this.timeage, this.id)
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;

  ul {
    display: flex;
    border-bottom: 1px solid #6c8fcd;
  }

  .dateinput {
    width: 250px !important;
  }

  li {
    display: flex;
    width: 250px;
    justify-items: center;
    align-items: center;
    text-align: center;
    flex-wrap: wrap;
    padding: 5px;
    color: #fff !important;
    //box-shadow: 1px 1px 5px 1px #468880;
    //border-bottom: 1px solid #c8946e;
    //border-radius: 5px;
    box-sizing: border-box;
    /* 这里设置为wrap，表示子元素可以换行 */
  }

  li span {
    width: 100%;
    margin-top: 5px;
    letter-spacing: 1px;
    /* 调整文字之间的间距，根据需要进行调整 */
  }

  li :nth-child(1) {
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 2px;
  }

  .date-picker {
    margin-top: 10px;
  }

  .el-icon-delete {
    display: inline-block;
    color: #db7913;
    font-size: 20px !important;
    font-weight: bold !important;
    opacity: 1 !important;
  }

  .el-icon-delete:hover {
    font-size: 25px !important;
    color: #2ad1c4;
  }
}
</style>